import { useMemo } from "react";
import { DataTable, Page } from "@iq/models";

const PORTAL_REQUESTS_TABLE_CONFIG = {
	columns: [
		{ key: "requestNumber", label: "Request #", accessor: "requestNumber", filterable: false, width: ".7fr" },
		{ key: "submittedAt", label: "Submitted", accessor: "submittedAt", filterable: true, quickValues: ["Most Recent", "Oldest"], width: "1fr" },
		{ key: "subject", label: "Subject", accessor: "subject", filterable: true, width: "1.6fr" },
		{ key: "requester", label: "Requester", accessor: "requester", filterable: true, width: "1.1fr" },
		{ key: "client", label: "Client", accessor: "client", filterable: true, width: "1fr" },
		{ key: "status", label: "Status", accessor: "status", filterable: true, quickValues: ["New", "Converted", "Closed", "Cancelled"], width: ".8fr" },
		{ key: "incidentNumber", label: "Incident", accessor: "incidentNumber", filterable: false, width: "1fr" },
	],
};

function formatTimestamp(value) {
	if (!value) {
		return "-";
	}
	const parsed = new Date(value);
	return Number.isNaN(parsed.getTime()) ? String(value) : parsed.toLocaleString();
}

export default function PortalRequests({
	portalRequests = [],
	clients = [],
	loading = false,
	error = "",
	onSelect,
}) {
	const clientMap = useMemo(
		() => new Map((Array.isArray(clients) ? clients : []).map((client) => [String(client?.id ?? ""), client?.name || `Client #${client?.id ?? "?"}`])),
		[clients],
	);

	const rows = useMemo(
		() => (Array.isArray(portalRequests) ? portalRequests : []).map((request) => ({
			...request,
			requestNumber: `REQ-${request?.id ?? ""}`,
			submittedAt: formatTimestamp(request?.created_at),
			subject: request?.subject || "Untitled request",
			requester: request?.submitted_by_name || request?.submitted_by_email || "Unknown",
			client: request?.client_id != null
				? clientMap.get(String(request.client_id)) || `Client #${request.client_id}`
				: "Unassigned",
			status: request?.status || "new",
			incidentNumber: request?.incident?.number || "-",
		})),
		[portalRequests, clientMap],
	);

	return (
		<Page>
			{error ? <p style={{ color: "var(--color-danger)", marginBottom: 12 }}>{error}</p> : null}
			<DataTable
				rowData={rows}
				loading={loading}
				tableConfig={PORTAL_REQUESTS_TABLE_CONFIG}
				onRowClick={(request) => onSelect?.(request)}
			/>
		</Page>
	);
}